module.exports = __webpack_public_path__ + "img/smiley.99f7cc81.svg";